import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Instagram, Youtube, Menu, X } from 'lucide-react';
import { NAV_LINKS } from '../mock';

const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const isActive = (href) => {
    if (href === '/') return location.pathname === '/';
    if (href.startsWith('/')) return location.pathname === href;
    return false;
  };

  const linkFor = (href, children, extra = '') => {
    if (href.startsWith('#')) {
      return (
        <a href={location.pathname === '/' ? href : `/${href}`} className={`nav-link text-[15px] ${extra}`} onClick={() => setOpen(false)}>{children}</a>
      );
    }
    return (
      <Link to={href} className={`nav-link text-[15px] ${extra} ${isActive(href) ? 'active' : ''}`} onClick={() => setOpen(false)}>{children}</Link>
    );
  };

  return (
    <header className="w-full bg-white sticky top-0 z-50 shadow-[0_2px_18px_-8px_rgba(10,44,77,0.15)]">
      <div className="max-w-[1280px] mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <span className="mid-logo-mark">M</span>
          <span className="font-serif-display text-2xl md:text-3xl font-bold text-[#0a2c4d] tracking-tight">Midbrothers</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <React.Fragment key={l.label}>{linkFor(l.href, l.label)}</React.Fragment>
          ))}
          <Link to="/retirement" className={`nav-link text-[15px] font-semibold ${isActive('/retirement') ? 'active' : ''}`} onClick={() => setOpen(false)}>Retirement Planning</Link>
        </nav>

        <div className="hidden md:flex items-center gap-2">
          <a href="#" className="social-ico" aria-label="Facebook"><Facebook size={15} /></a>
          <a href="#" className="social-ico" aria-label="Twitter"><Twitter size={15} /></a>
          <a href="#" className="social-ico" aria-label="LinkedIn"><Linkedin size={15} /></a>
          <a href="#" className="social-ico" aria-label="Instagram"><Instagram size={15} /></a>
          <a href="#" className="social-ico" aria-label="YouTube"><Youtube size={15} /></a>
        </div>

        <button className="lg:hidden text-[#0a2c4d]" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-gray-100 bg-white">
          <div className="px-6 py-4 flex flex-col gap-3">
            {NAV_LINKS.map((l) => (
              <React.Fragment key={l.label}>{linkFor(l.href, l.label, 'py-2')}</React.Fragment>
            ))}
            <Link to="/retirement" className="nav-link py-2 font-semibold" onClick={() => setOpen(false)}>Retirement Planning</Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
